import { render } from "./RecommendationResults.vue?vue&type=template&id=f25dc0fa&scoped=true"
import script from "./RecommendationResults.vue?vue&type=script&lang=js"
export * from "./RecommendationResults.vue?vue&type=script&lang=js"

import "./RecommendationResults.vue?vue&type=style&index=0&id=f25dc0fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f25dc0fa"]])

export default __exports__